jQuery(document).ready(function($) {
  if (!!navigator.userAgent.match(/Trident.*rv[ :]*11\./)) {
    $("html").addClass("ie11");
  }
  if ($.browser.msie && $.browser.version == 10) {
    $("html").addClass("ie10");
  }
  if ($.browser.msie && $.browser.version == 9) {
    $("html").addClass("ie9");
  }

	$('audio').mediaelementplayer({audioWidth: 230});

	/*setTimeout(function() {
      $("#popup-overlay,#popup-wrapper-info").show();
	}, 4000);

	setTimeout(function() {
      $("#popup-overlay,#popup-wrapper-info").hide();
	},10000);*/

	$("#edit-qty").keyup(function(){
		$('#custom_add_to_cart_default [name="qty"]').val($(this).val());
	});

	$('#header-top').append('<div class="right-black">');
	$('.right-black').width((parseFloat($(window).width())-1200)/2);
	$( window ).resize(function() {
		$('.right-black').width((parseFloat($(window).width())-1200)/2);
	});
	$("#edit-sort-by, #edit-items-per-page").selectbox({
		onChange : function(){
			$(this).closest('form').submit();
		}
	});
	/*---------------------Search form home page start------------*/
  $("#edit-search-block-form--2").attr("placeholder","Search");
	$("#static-search-form a").toggle(function(){
			$(this).parent().animate({right:'0px'},{queue: false, duration: 500});
		},
		function(){
			$(this).parent().animate({right:'-274px'},{queue: false, duration: 500});
	});
	$("body").click(function(){
		$("#static-search-form").animate({right:'-274px'},{queue: false, duration: 500});
	});
  $("#static-search-form").click(function(e){
		e.stopPropagation();
	});

  /*--------------------- Home product slider ------------*/
  assignSlider = function(id){
    // remove active class from all products and bottom links
    $("#min-slider ul.min-slider-album li").removeClass("active");
    $('.slider-tab-menu li').removeClass('active');
    // add active class to appropriate products and bottom link
    $("#min-slider ul.min-slider-album li." + id).addClass("active");
    $('.slider-tab-menu li.' + id).addClass('active');
  }

	/*-------------------------------------  text resize  -------------------------------------*/

  // Increase Font Size
  $(".plus").click(function(){
    var currentFontSize = $('.knowledge-center-body, .knowledge-center-body p, .node-type-blog .field-name-body p, .page-node-5 .field-name-body p, .page-node-21 .field-name-body p, .content-info p, .content-info, .rte, .te p ').css('font-size');
    var currentFontSizeNum = parseFloat(currentFontSize, 10);
    var newFontSize = currentFontSizeNum+2;

		if ( newFontSize < 30 ) {
		 	$('.knowledge-center-body, .knowledge-center-body p, .node-type-blog .field-name-body p, .page-node-5 .field-name-body p, .page-node-21 .field-name-body p, .content-info p, .content-info, .rte, .rte p ').css('font-size', newFontSize);
		}
    return false;
  });
  // Decrease Font Size
  $(".minus").click(function(){
    var currentFontSize = $('.knowledge-center-body, .knowledge-center-body p, .node-type-blog .field-name-body p, .page-node-5 .field-name-body p, .page-node-21 .field-name-body p, .content-info p, .content-info, .rte, .rte p ').css('font-size');
    var currentFontSizeNum = parseFloat(currentFontSize, 10);
    var newFontSize = currentFontSizeNum-2;

		if ( newFontSize > 8 ) {
		 	$('.knowledge-center-body, .knowledge-center-body p, .node-type-blog .field-name-body p, .page-node-5 .field-name-body p, .page-node-21 .field-name-body p, .content-info p, .content-info, .rte .rte p ').css('font-size', newFontSize);
		}
    return false;
  });

  /*-------------------------------------  social share buttons  -------------------------------------*/

  $('.twitter').sharrre({
    url : 'https://galilee-of-the-nations.myshopify.com',
    share: {twitter: true},
    template: '<a class="box" href="#"><span class="share">Tweet</span><span class="count" href="#">{total}</span></a>',
    enableHover: false,
    enableTracking: true,
    buttons: { twitter: {via: 'galileemusic'}},
    click: function(api, options){
      api.simulateClick();
      api.openPopup('twitter');
    }
  });
  $('.facebook').sharrre({
    share: {facebook: true},
    template: '<a class="box" href="#"><span class="share">Like</span><span class="count" href="#">{total}</span></a>',
    enableHover: false,
    enableTracking: true,
    click: function(api, options){
      api.simulateClick();
      api.openPopup('facebook');
    }
  });
  $('.googleplus').sharrre({
    share: {googlePlus: true},
    urlCurl: '',
    template: '<a class="box" href="#"><span class="share">Google+</span><span class="count" href="#">{total}</span></a>',
    enableHover: false,
    enableTracking: true,
    click: function(api, options){
      api.simulateClick();
      api.openPopup('googlePlus');
    }
  });

  /*-------------------------------------  slick navigation  -------------------------------------*/
  $('#menu').slicknav();

  /*-------------------------------------  about page slider  -------------------------------------*/
  $('#about-slider .field > .field-items').cycle({
		fx: 'scrollHorz',
		speed: 'slow',
		timeout: 0,
		next: '.about-next',
		prev: '.about-previous'
	});

	$(".read-more-text").closest('p').next('p').hide();
	$(".read-more-text").next('a.read-less-text').hide();

	$(".read-more-text").click(function(){
		$(".read-more-text").closest('p').next('p').show();
		$(".read-more-text").next('a.read-less-text').show();
		$(this).hide();
	});
	$(".read-less-text").click(function(){
		$(this).closest('p').next('p').hide();
		$('a.read-more-text').show();
		$(this).hide();
	});
	$(window).load(function(){
		setInterval(anim, 7000);

		$("#pagination-top li").click(function(){
			$("#pagination-top li").removeClass("active_bg");
			$(this).addClass('active_bg');
			var i = $(this).index()+1;
			var t = $("#wrap .animate_bg[order="+i+"]").index();
			for( var j = 0; j < 3; j++ ) {
				if($("#wrap .animate_bg").first().attr('order') == i){
					return false;
				}
				$("#wrap .animate_bg").first().appendTo('#wrap').fadeOut(1500);
				$("#wrap .animate_bg").first().fadeIn(1500);
			}
		});
	});

	/*----------code for parallax effect --------------*/
	$(window).scroll(function(){
		$(".bg-5").css("backgroundPosition","center "+($(window).scrollTop()/2 )+"px");
	});

/*---------------------artists slider------------*/
	$('.artist-slider .view-content,.view-popular-artist .view-content').cycle({
		fx:     'scrollHorz',
		speed:  'slow',
		timeout: 0,
		next:   '.next-artist',
		prev:   '.prev-artist'
	});
	$('.view-id-endorsements .view-content').cycle({
		fx:     'scrollHorz',
		speed:  'slow',
		timeout: 0,
		next:   '.next-testimonial',
		prev:   '.prev-testimonial'
   });

	/*---------------------footer slider------------*/
	$('#block-views-special-offer-slider-block .view-id-special_offer_slider .view-content').after('<div id="pagination">').cycle({
		fx:     'scrollHorz',
		speed:  'slow',
		timeout: 5000,
		pager:  '#pagination'
   });

	$("#login-popup-link,.fivestar-widget-static").click(function(){
   	$("#popup-overlay,#popup-wrapper").show();
   });
   $("#close-popup,#close-popup1").click(function(){
		$("#popup-overlay,#popup-wrapper,#popup-wrapper-new,#popup-wrapper-info").hide();
   });

	$('.node-type-product .detail-artist-img .field-item').zoom();
	$('#primary-menu .content > ul > li > a').after("<span></span>");

	var artist_link = $(".artist-name a").attr('href');
	$("#block-views-popular-artist-block .view-id-music > ul,#block-views-popular-artist-block-1 .view-id-music > ul").each(function(){
		$(this).append("<li><div class=see-all><a href="+$(this).closest('.views-row').find('.artist-name a').attr('href')+">See All  </a></div></li>");
	})
	$("#block-views-music-block-1 .view-id-music ul").append("<li><div class=see-all><a href=/catalog/music>See All  </a></div></li>");
	$(".view-id-artist_you_following ul").append("<li><div class=see-all><a href=/artists>See All  </a></div></li>");
	$(".artist-image-wrapper .see-all").remove();

  /*---------------------about slider ------------*/
	$( "#min-slider > ul li" ).hover(function() {
		$( this ).stop(true).animate({"margin-top":"-12px"},500);
		},function(){
		$( this ).stop(true).animate({"margin-top":"0"},500);
	});

	$(".next").click(function(){
		if($(".mi-selected").next().length > 0){
			$(".mi-selected").next().click();
		}
		else{
			$(".nav li").eq(0).click();
		}
	});

	setTimeout(function() {
      $(".next").click();
	}, 5000);
	$(".prev").click(function(){
		if($(".mi-selected").prev().length > 0){
			$(".mi-selected").prev().click();
		}
		else{
		$(".nav li").last().click();
		}
	});

	$("#drop-down-icon span").click(function(){
		$(this).toggleClass("drop");
		$(".gotn-center > a").slideToggle("slow");
		$(".welcome-wrapper > span").slideToggle("slow");
		$("#block-views-highlight-block .gotn-welcome-info-wrapper").animate({ 'padding-top':0,'padding-bottom':0}, 1000);
		$("#block-views-highlight-block .gotn-center").animate({ 'padding-top':7}, 1000);
	});

	/*-----code for user dropdown --------*/
	$(".user-welcome-block").click(function(event){
		$(this).closest("div").toggleClass("active");
		event.stopPropagation();
	});
	$(document).click(function() {
		$('.user-welcome-block').removeClass('active');
	});

	$("#uc-cart-view-form table.sticky-enabled, .page-cart-checkout-review table, .page-user-orders table, #uc-cart-checkout-form table.sticky-enabled").addClass("table");
	$("#uc-cart-checkout-form table.sticky-enabled td.price, #uc-order-total-preview td.price").addClass("item-price");
	$("#uc-cart-checkout-form table.sticky-enabled th.price").removeClass("price");

	/*---------------------home page move arrow start------------*/
	$(".nav li").click(function(e){
		var position = $(this).position();
		var li_width = $(this).outerWidth();
		$(".slider-tab-menu").css("backgroundPosition",((position.left-1204)+(li_width/2))+"px top");
		e.preventDefault();
	 });

	/*---------------------add placeholder to the contact us form start------------*/
	$("#views-exposed-form-blog-page-page #edit-combine").attr("placeholder","Search");
	$("#views-exposed-form-uc-catalog-page-3 #edit-combine").attr("placeholder","Search");
	$("#views-exposed-form-knowledge-base-page-1 #edit-combine").attr("placeholder","Search");

  /*---------------------------------*/
	$('#fade').cycle({timeout:10000,});

	$(".song-symbols ul li").each(function(){
		$(this).addClass($(this).html().toLowerCase());
	});
	$(".song-symbols ul").each(function(){
		$(this).find("li:gt(1)").remove();
	});
	$(".song-popularity").each(function(){
		$(this).css('width',$(this).find('div').html());
	});
	$(".song-popularity").each(function(){
		$(this).css('width',$(this).html());
	});

	/*---------------------------------- Update songs duration code-----------------------------*/
	$(".update-single-song").click(function(){
			$.ajax({
				type: 'POST',
					url: 'https://galileeofthenations.com/updatesongs.php',
					data: {"album_id":$(this).closest('td').find('.update-data').attr('name'),"action":"add","duration":$(this).closest('td').find('.update-data').val() },
					success: function(data, textStatus, XMLHttpRequest) {
						alert(data);
					}
			});
	});
	/*---------------------------------- Create single song download url code-----------------------------*/
	$(".update-single-songtitle").click(function(){
			$.ajax({
				type: 'POST',
					url: 'https://galileeofthenations.com/updatesongstitle.php',
					data: {"song_id":$(this).closest('td').find('.update-song-url').attr('name'),"action":"add","download-file":$(this).closest('td').find('.update-song-url').                           val() },
					success: function(data, textStatus, XMLHttpRequest) {
						alert(data);
					}
			});
	});

	/*--------code for tooltip -----------*/
	$(".form-type-uc-quantity :input:[readonly]").hover(function(){
        	// Hover over code
        	$('<p class="qty-tooltip"></p>')
         .text('This is a digital product, quantity can not be increased for this product!')
         .appendTo('body')
			.fadeIn('fast');
		}, function() {
			  // Hover out code
			$('.qty-tooltip').remove();
		}).mousemove(function(e) {
			var mousex = e.pageX + 20; //Get X coordinates
			var mousey = e.pageY - 30; //Get Y coordinates
			$('.qty-tooltip').css({ top: mousey, left: mousex })
	});

	$('.img-tooltip').hover(function(){
        	// Hover over code
        	var title = $(this).attr('title');
        	$(this).data('tipText', title).removeAttr('title');
        	$('<p class="album-tooltip"></p>')
         .text(title)
         .appendTo('body')
			.fadeIn('fast');
		}, function() {
			  // Hover out code
			$(this).attr('title', $(this).data('tipText'));
			$('.album-tooltip').remove();
		}).mousemove(function(e) {
			var mousex = e.pageX + 20; //Get X coordinates
			var mousey = e.pageY + 10; //Get Y coordinates
			$('.album-tooltip').css({ top: mousey, left: mousex })
	});
	$('#custom_add_to_cart .form-submit').val('Purchase MP3 Album');
	$('#custom_add_to_cart_default .form-submit').val('Buy CD');
	$('#primary-menu .menu').slicknav();
   function anim() {
	$(".template-index #wrap .animate_bg").first().appendTo('#wrap').fadeOut(1500);
	$(".template-index #wrap .animate_bg").first().fadeIn(1500);
	var i = $(".template-index #wrap .animate_bg").first().attr("order")-1;
	$("#pagination-top li").not(":eq("+i+")").removeClass("active_bg");
	$("#pagination-top li").eq(i).addClass('active_bg');
	}

	/*---------------------home category slider open------------*/
	$(function() {
		$( '#min-slider' ).catslider();
	});

	$(function(){
		$(".special-offer-login-form form > div > div:lt(4)").wrapAll("<div class='special-offer-left'>");
		$(".special-offer-login-form form #edit-name").attr("placeholder","Username");
		$(".special-offer-login-form form #edit-pass").attr("placeholder","Password");
	});

	//*---------------------home category slider closed------------*/
	(function() {
		 var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
		 po.src = 'https://apis.google.com/js/platform.js';
		 var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
	})();

	$(function(){
		$("#user-register-form .hybridauth-widget-wrapper h3").html("Log in with");
		$("#user-register-form .hybridauth-widget-wrapper").appendTo(".register-share");
	});


	$('#edit-panes-payment-payment-method .form-radio').change(function(){
		if($(this).val() == 'credit'){
			$('#payment-details').slideDown();
		}
		else{
			$('#payment-details').slideUp();
		}
	});

	if($('#edit-panes-payment-payment-method .form-radio:checked').val() == 'credit'){
		$('#payment-details').show();
	}
	else{
		$('#payment-details').hide();
	}
});
